<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Payment Terminal</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form (submit)="handleSave()">

  <div class="modal-body">
    <div class="form-group">
      <label for="registrationCodeInput">Registration Code</label>
      <input id="registrationCodeInput" type="text" class="form-control" name="registrationCode"
             required
             [(ngModel)]="registrationCode">
      <small class="form-text text-muted">This code is obtained from your terminal's settings page.</small>
    </div>
    <div class="form-group">
      <label for="labelInput">Label</label>
      <input id="labelInput" type="text" class="form-control" name="label"
             required
             [(ngModel)]="label">
    </div>

    <div class="alert alert-info">This payment terminal will be registered for {{ location.name }}.</div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="submit" class="btn btn-primary"
            *ngIf="!loadingSubmit">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

  </form>

</ng-container>
